import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import {
  BaseRatePackageView,
  OfferPackageOptionView,
  getBaseRatePackagesView,
} from 'selectors/offerPage/offerPageSelectors'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { isLPCTacticalEnabled } from 'lib/offer/offerUtils'
import { OFFER_TYPE_ALWAYS_ON } from 'constants/offer'
import AlwaysOnOfferPromotion from 'components/OfferPage/AlwaysOn/AlwaysOnOfferPromotion'

interface Props {
  offer: App.Offer;
  promotions: Array<OfferPackageOptionView>;
  checkIn?: string;
  rooms: Array<App.Occupants>;
  baseRatePackagesView: Array<BaseRatePackageView>
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${rem(36)} !important;

  > * + * {
    margin-top: ${rem(20)};
  }
`

function OfferPromotions(props: Props) {
  const {
    offer,
    promotions,
    checkIn,
    rooms,
    baseRatePackagesView,
  } = props

  if (!isLPCTacticalEnabled()) {
    return null
  }

  let OfferPromotion
  if (offer?.property?.isUltraLux) {
    OfferPromotion = AlwaysOnOfferPromotion
  } else if (offer.type === OFFER_TYPE_ALWAYS_ON) {
    OfferPromotion = AlwaysOnOfferPromotion
  } else {
    return null
  }

  const maxPromotionsCount = 2
  const visiblePromotions = promotions.slice(0, maxPromotionsCount)

  return <Container>
    <div>
      <Heading variant="heading3">Current promotions</Heading>
      <BodyText variant="medium" as="p">Available for select rooms only</BodyText>
    </div>
    {visiblePromotions.map(promotion => {
      return (
        <OfferPromotion
          key={promotion.package.uniqueKey}
          promotion={promotion}
          offer={offer}
          checkIn={checkIn}
          rooms={rooms}
          baseRatePackagesView={baseRatePackagesView}
        />
      )
    })}
  </Container>
}

export default withOfferPageAndReduxState((state, appState) => ({
  rooms: state.rooms,
  checkIn: state.checkInDate,
  baseRatePackagesView: getBaseRatePackagesView(appState, state),
}), OfferPromotions)
